import React, { useEffect, useState } from "react";
import PageRoutes from "../../../Routes/Routes";
import { useDispatch, useSelector } from "react-redux";
import Footer from "../../Footer/Footer";
import Navbar from "../../Navbar/Navbar";
import Sidebar from "../../Sidebar/Sidebar";
import "../Layout.scss";
import { useLocation } from "react-router-dom";

const AppLayout = () => {
  const [sidebarOpen, setSidebarOpen] = React.useState(true);
  let sectionFilings = useSelector((state) => state.survey?.sectionFilings);
  const supSectionFiling = useSelector(
    (state) => state?.survey?.supSectionFiling
  );

  if (supSectionFiling && supSectionFiling.length > 0) {
    sectionFilings = [...sectionFilings, ...supSectionFiling];
  }

  const toggleSidebar = (open) => {
    setSidebarOpen(!open);
  };

  return (
    <div className="app-layout">
      <Navbar toggleSidebar={toggleSidebar} />
      <div className="main-layout">
        <Sidebar open={sidebarOpen} section={sectionFilings} />
        <main style={{ width: "100%", overflow: "auto" }}>
          <PageRoutes />
        </main>
      </div>
      <Footer />
    </div>
  );
};

export default AppLayout;
